import { Col, Form, Input, Row } from 'antd';
import { processPastedData } from '../utils/processPastedData';
import { ColumnConfig, DataRow } from '../../@types/data/types';

interface DynamicFormProps {
  columns: ColumnConfig[];
  data: DataRow[];
  onDataChange: (newData: DataRow[]) => void;
}

const DynamicForm = ({ columns, data, onDataChange }: DynamicFormProps) => {
  const handleValueChange = (rowIndex: number, columnKey: string, value: string) => {
    const newData = data.map((row, i) => {
      if (i === rowIndex) {
        return { ...row, [columnKey]: value };
      }
      return row;
    });
    onDataChange(newData);
  };

  const handlePaste = (startRowIndex: number, event: React.ClipboardEvent<HTMLInputElement>) => {
    event.preventDefault();
    const pastedText = event.clipboardData.getData('text/plain');
    const pastedData = processPastedData(pastedText);

    if (pastedData.length === 0) return;

    const desiredDataLength = Math.max(data.length, startRowIndex + pastedData.length);
    let dataCopy = [...data];

    pastedData.forEach((pastedRow, rowIndex) => {
      const targetIndex = startRowIndex + rowIndex;
      if (!dataCopy[targetIndex]) {
        dataCopy[targetIndex] = columns.reduce((acc, col) => ({ ...acc, [col.key]: '' }), {});
      }
      pastedRow.forEach((cellValue, colIndex) => {
        const columnKey = columns[colIndex]?.key;
        if (columnKey) {
          dataCopy[targetIndex][columnKey] = cellValue;
        }
      });
    });

    let finalData = Array.from({ length: desiredDataLength }, (_, i) => dataCopy[i] || columns.reduce((acc, col) => ({ ...acc, [col.key]: '' }), {}));

    const emptyRow = columns.reduce((acc, col) => ({ ...acc, [col.key]: '' }), {});
    finalData.push(emptyRow);

    onDataChange(finalData);
  };

  const colSpan = Math.floor(24 / columns.length) || 24;

  return (
    <div>
      <Row gutter={16} style={{ marginBottom: '0.5rem' }}>
        {columns.map(col => (
          <Col span={colSpan} key={col.key}>
            <strong>{col.header}</strong>
          </Col>
        ))}
      </Row>

      {data.map((row, rowIndex) => (
        <Row key={rowIndex} gutter={16} align="middle">
          {columns.map(col => (
            <Col span={colSpan} key={col.key}>
              <Form.Item style={{ marginBottom: '8px' }}>
                <Input
                  value={row[col.key] || ''}
                  onChange={e => handleValueChange(rowIndex, col.key, e.target.value)}
                  onPaste={e => handlePaste(rowIndex, e)}
                />
              </Form.Item>
            </Col>
          ))}
        </Row>
      ))}
    </div>
  );
};

export default DynamicForm;